import PropTypes from "prop-types";
import styles from "./styles";

export const ErrorMessage = ({ message, id }) => {
  return (
    <span className={styles.errorMessage} id={id} role="alert">
      {message}
    </span>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  id: PropTypes.string,
};

ErrorMessage.defaultProps = {
  message: "",
  id: undefined,
};
